import type {
  DataSet,
  NumericDomain,
  NumericPoint,
  Point,
  Threshold
} from "@incytestudios/ddv";
import type { GasCurveChartContext } from "./d";
import { Ratio } from "@/libs/units/percentage";
import { getGasLockRatioForPump } from "../../calculations/pumps/pumpData";

const getDataPoints = (context: GasCurveChartContext): Point[] => {
  const { ascendingOrderPumps } = context;
  return ascendingOrderPumps.reduce<NumericPoint[]>(
    (points, xrefPump, currentIndex) => {
      const previousStages = ascendingOrderPumps
        .slice(0, currentIndex)
        .reduce(
          (sum, previousXrefPump) =>
            previousXrefPump.total_stages
              ? (sum += previousXrefPump.total_stages)
              : sum,
          0
        );
      const x = previousStages + 1;
      const gasLockRatio = getGasLockRatioForPump(xrefPump);

      points.push({
        x,
        y: Ratio.toStandardUnit(gasLockRatio)
      });

      points.push({
        x: x + (xrefPump.total_stages || 1),
        y: Ratio.toStandardUnit(gasLockRatio)
      });
      return points;
    },
    []
  );
};

export const getMaxGasAllowedDataSet = (
  context: GasCurveChartContext,
  pumpThresholds: Threshold[]
): DataSet => {
  const points = getDataPoints(context);
  return {
    title: "Max Gas Allowed",
    xAxisLabel: "Stage",
    yAxisLabel: "% Gas Allowed",
    points,
    yDomain: { min: 0, max: 100 },
    thresholds: {
      x: pumpThresholds
    }
  };
};
